import storeManager from '../../store/StoreManager';
import {showCroppingMenu, showZoomSlides} from '../../actions/MenuActions';

const zoomUtils = {
    currentHotspot: undefined,
    currentBackgroundUid: undefined,
    updateInitialPosition: true,

    croppingTarget: undefined,
    currentCroppingHotspot: undefined,
    updateCurrentCroppingHotspot: undefined,
    updateTransformTool: undefined,
    updateCroppingInitialPosition: true,
    croppingTargetRotation: 0,

    closeZoom () {
        const dispatch = storeManager.getStore().dispatch;
        dispatch(showZoomSlides(false));
        dispatch(showCroppingMenu(false));
    },
    isCroppingMode() {
        const state = storeManager.getState();
        var showCroppingMenu = state.menu && state.menu.showCroppingMenu;

        if (showCroppingMenu == true)
            return true;
        else
            return false;
    },
    goToFullScreenMode() {
        var el = document.body;

        // Supports most browsers and their versions.
        var requestMethod = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullScreen;

        if (requestMethod) {
            // Native full screen.
            requestMethod.call(el);
        }
    }
};

export default zoomUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/ZoomUtils.js
 **/